export const PRESENTATION = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline'
};
